<template>
  <p class="text-center">makro</p>
</template>

<script>
export default {
  name: "FooterTemplate",
};
</script>